import styled from "styled-components";
import Variables from "../../assets/styleVariables";
import { BoxContainer } from "../../assets/globalStyles/styledSettingBox";

export const Hint = styled.div`
  font-size: ${Variables.font_sizes.x1_medium};
  color: ${Variables.colors.complementary_700};
  line-height: 1.6;
  margin-bottom: 16px;
  padding: 0 12px 16px;
  text-align: justify;
  max-width: ${props => (props.maxWidth ? props.maxWidth + "px" : "")};
`;

export const LevelContainer = styled.div`
  padding: 16px 12px;
  background-color: ${Variables.colors.complementary_50};
  margin-bottom: 24px;

  .main-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: ${Variables.font_sizes.x2_medium};
    color: ${Variables.colors.complementary_800};
    margin-bottom: 24px;
    position: relative;
  }
  .approvers-container {
    padding: 0 12px;
    .add-approver {
      width: 230px;
    }
  }
`;

export const ApproverContainer = styled.div`
  border: 1px solid ${Variables.colors.complementary_400};
  background-color: ${Variables.colors.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px;
  margin-bottom: 10px;
  font-size: ${Variables.font_sizes.x1_medium};
  color: ${Variables.colors.complementary_700};
  position: relative;
`;

export const Box = styled.form`
  max-height: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 16px 8px;
`;

export const LevelBox = styled.div`
  padding: 12px 16px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${Variables.font_sizes.x2_medium};
  color: ${Variables.colors.complementary_800};
  background-color: ${Variables.colors.complementary_50};
  .arrows-wrapper {
    display: flex;
    justify-content: center;
  }
`;

export const Arrow = styled.i`
  transform: ${props => (props.down ? "rotate(-90deg)" : "rotate(90deg)")};
  visibility: ${props => (props.show ? "visible" : "hidden")};
`;

export const BorderedBox = styled(BoxContainer)`
  width: calc(100% - 444px);
  overflow-y: auto;
  padding: 16px 8px 72px 8px;
`;
